export default {
    fileUploadConfig: {
        page: {
            StorageType: '存储类型',
            ViewConfiguration: '查看容量配置',
        },
        table: {
            Grouping: '分组',
            UploadDirectory: '上传目录',
            FileClassification: '文件分类',
            FileFormat: '文件格式',
            limitSize: '文件大小限制',
            unitSize: '文件大小单位',
            Operation: '操作',
        },
        dialog: {
            Grouping: '分组',
            UploadDirectory: '上传目录',
            FileClassification: '文件分类',
            FileFormat: '文件格式',
            limitSize: '文件大小限制',
            EditTitle: '编辑上传详细配置',
            CreateTitle: '新建上传详细配置'
        },
    },
};
